import { bootstrapApplication } from '@angular/platform-browser';
import { provideGlobalGridOptions } from 'ag-grid-community';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { contextMenuWithoutExport } from './app/shared/grid-export';

// Every grid: no Export in the right-click menu, so exports go through the
// page Export buttons, which are recorded in the user activity log.
provideGlobalGridOptions({ getContextMenuItems: contextMenuWithoutExport });

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
